// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { UpdatesAreaId } from './UpdatesAreaId'
import { UpdatesAreaNavigation } from './UpdatesAreaNavigation'
import { UpdatesAreaRoutes } from './UpdatesAreaRoutes'

const LazyUpdatesComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./UpdatesArea')),
)

const UpdatesComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyUpdatesComponent />
  </SuspenseLoadingWrapper>
)

export const UpdatesArea = {
  id: UpdatesAreaId,
  NavigationComponent: UpdatesAreaNavigation,
  route: {
    path: UpdatesAreaRoutes.route,
    component: UpdatesComponent,
  },
}
